$(document).ready(function () {
    $(".form__actions .button-send").on("click", function (e) {
      e.preventDefault();
      $(this).parents(".parent-form").find(".submit-form").trigger('click');
    });
  });
  